import { gql } from '@apollo/client';
import PostTitleWithIcons from '../../post/PostTitleWithIcons';

export default gql`
  fragment PostSummaryFields on Post {
    id
    archivedAt
    publishedAt
    updatedAt
    series {
      id
    }
    type
    topics {
      id
      name
      privacy
      inheritedAncestors {
        id
      }
    }
    ...PostTitleWithIcons_post
  }
  ${
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
    PostTitleWithIcons.fragments.post
  }
`;
